import { Button } from "@/components/ui/button";
import { Phone, Users } from "lucide-react";

export function OrderDeliveryInfo({ isDelivery, deliverer, order, setShowSwapDialog }) {
  if (!isDelivery) return null;

  return (
    <div>
      <h3 className="font-bold text-xs text-gray-500 uppercase tracking-wider mb-3">ENTREGADOR</h3>
      {deliverer ? (
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <Users className="w-4 h-4 text-emerald-600" /><span className="font-bold text-emerald-700 uppercase">{deliverer.name}</span>
            {deliverer.phone && <><Phone className="w-4 h-4 text-emerald-600 ml-2" /><span className="text-sm text-gray-600">{deliverer.phone}</span></>}
          </div>
          <Button variant="outline" className="w-full border-emerald-300 text-emerald-700 font-bold uppercase tracking-wide hover:bg-emerald-50 text-xs h-9" onClick={() => setShowSwapDialog(true)} data-testid="edit-deliverer-btn">EDITAR ENTREGADOR</Button>
        </div>
      ) : order.deliverer_id ? (
        <p className="text-xs text-gray-400 italic">Entregador nao encontrado</p>
      ) : order.status === "ready" ? (
        <p className="text-xs text-purple-600 font-medium">Atribua um entregador abaixo para despachar o pedido</p>
      ) : (
        <p className="text-xs text-gray-400 italic">Sem entregador atribuido</p>
      )}
    </div>
  );
}
